if ( typeof enforceCartIntegrity !== 'function' ) {

	// Removes Yotpo redemption (free) line items when the cart contains no
	// paid product, preventing checkout of a redemption-only cart. Reads
	// state from the #AjaxCartIntegrity marker rendered by the
	// jkl-cart-integrity-data snippet. Resolves to true when items were
	// removed, false otherwise.
	window.enforceCartIntegrity = function enforceCartIntegrity() {
		const integrity = document.getElementById('AjaxCartIntegrity');
		if ( ! integrity ) return Promise.resolve(false);

		const sellableCount = parseInt(integrity.dataset.sellableCount || '0', 10);
		const redemptionKeys = (integrity.dataset.redemptionKeys || '').split(',').filter(Boolean);

		if ( sellableCount > 0 || redemptionKeys.length === 0 ) {
			return Promise.resolve(false);
		}

		const updates = {};
		redemptionKeys.forEach(key => { updates[key] = 0; });

		return fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ updates })
		}).then(() => true);
	};

}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty, autocart = false){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = getCartErrorMessage(response);
					}
					return fetch('?section_id=helper-cart', { method: 'GET' });
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					const loyaltyPoints = document.getElementById('AjaxLoyaltyPoints');
					const loyaltyPointsNew = sectionInnerHTML.getElementById('AjaxLoyaltyPoints');
					if ( loyaltyPoints && loyaltyPointsNew ) {
						const newPoints = loyaltyPointsNew.dataset.totalPoints;
						loyaltyPoints.dataset.totalPoints = newPoints;
						const countEl = loyaltyPoints.querySelector('.jkl-loyalty-points__count');
						if ( countEl ) countEl.textContent = newPoints;
						if ( loyaltyPoints.dataset.hideIfZero === 'true' ) {
							loyaltyPoints.classList.toggle('is-hidden', parseInt(newPoints) === 0);
						}
					}

				})
				.then(() => enforceCartIntegrity())
				.then(needsRefresh => {
					if ( needsRefresh && typeof window.refreshCart === 'function' ) {
						return window.refreshCart();
					}
				})
				.then(() => {
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {

		return fetch('?section_id=helper-cart', { method: 'GET' })
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			const loyaltyPoints = document.getElementById('AjaxLoyaltyPoints');
			const loyaltyPointsNew = sectionInnerHTML.getElementById('AjaxLoyaltyPoints');
			if ( loyaltyPoints && loyaltyPointsNew ) {
				const newPoints = loyaltyPointsNew.dataset.totalPoints;
				loyaltyPoints.dataset.totalPoints = newPoints;
				const countEl = loyaltyPoints.querySelector('.jkl-loyalty-points__count');
				if ( countEl ) countEl.textContent = newPoints;
				if ( loyaltyPoints.dataset.hideIfZero === 'true' ) {
					loyaltyPoints.classList.toggle('is-hidden', parseInt(newPoints) === 0);
				}
			}

			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})
		.then(() => enforceCartIntegrity())
		.then(needsRefresh => {
			if ( needsRefresh ) {
				return window.refreshCart();
			}
		});

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}